import React from 'react';

import TextField from 'material-ui/TextField';
import NumberField from '../../../Base/NumberField';
import api from 'services';
import { showNotification } from 'helpers';

class ImoNumber extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            imoNumber: props.imoNumber,
            hasError: props.getError('imoNumber'),
            disabled: false,
            confirmed: props.confirmed,
        };

        this.changeAndCheckImoNumber = this.changeAndCheckImoNumber.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.imoNumber !== this.state.imoNumber
            || this.state.hasError.length > 0
            || nextProps.getError('name').length > 0
            || nextProps.confirmed !== this.state.confirmed;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            imoNumber: nextProps.imoNumber,
            hasError: nextProps.getError('imoNumber'),
            disabled: nextProps.typeOfPage !== 'new',
            confirmed: nextProps.confirmed,
        });
    }

    changeAndCheckImoNumber(e, value) {
        const re = /^[0-9]*$/gm;

        if (value[0] === '0') {
            return this.setState({
                imoNumber: '',
            }, () => {
                this.props.changeField({
                    field: 'imoNumber',
                    value,
                });
            });
        }

        if (re.test(value) && value.length < 7) {
            return this.setState({
                imoNumber: parseInt(value, 10),
                hasError: '',
            }, () => {
                this.props.changeField({
                    field: 'imoNumber',
                    value,
                });
            });
        } else if (value.length === 7) {
            this.setState({
                imoNumber: parseInt(value, 10),
            }, () => {
                api.checkImoNumberRegistered(value)
                    .then((registered) => {
                        if (registered) {
                            this.setState({
                                hasError: 'imoNumber already exist',
                            })
                        } else {
                            this.setState({
                                hasError: ''
                            }, () => {
                                this.props.changeField({
                                    field: 'imoNumber',
                                    value,
                                });
                            })
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        showNotification('Request failed', 'error');
                    });
            });

        } else if (value.length > 7) {
            return this.setState({
                imoNumber: value.replace(value.substring(value.length-1), ""),
                hasError: '',
            });
        }
    }

    render() {
        const { imoNumber, hasError, disabled, confirmed } = this.state;
        const { modifiedFields, underStyle } = this.props;

        return (
            <NumberField
                name='imoNumber'
                type='number'
                floatingLabelText='IMO NO'
                value={imoNumber || ''}
                errorText={hasError}
                disabled={disabled || confirmed}
                onChange={this.changeAndCheckImoNumber}
                fullWidth

                underlineStyle={modifiedFields && modifiedFields.includes('imoNumber') ? underStyle : null}
            />
        );
    }
}

export default ImoNumber


// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/ImoNumber.jsx